import SellYourBusinessRouter from './SellYourBusiness.router';

export default SellYourBusinessRouter;

export { default as sellYourBusinessRoutes } from './routes';
